import { Redirect, Route } from "react-router-dom";
import { IonApp, IonRouterOutlet, setupIonicReact } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { setupInterceptors } from "./http-interceptors";
import { AuthProvider, ProtectedRoute, useAuth } from "./hooks/auth";
import { SWRConfig } from "swr";

import { useEffect } from "react";

import axios from "axios";
import Config from "./pages/ConfigPage";
import LoginPage from "./pages/LoginPage";

import "./global.scss";
import "./theme/variables.scss";

setupIonicReact();
setupInterceptors();

const App: React.FC = () => (
  <IonApp>
    <SWRConfig value={{ fetcher: (url) => axios.get(url).then((res) => res.data) }}>
      <AuthProvider>
        <Router />
      </AuthProvider>
    </SWRConfig>
  </IonApp>
);

export default App;

function Router() {
  return (
    <IonReactRouter>
      <IonRouterOutlet>
        <Route path="/" exact>
          <Redirect to="/config" />
        </Route>
        <Route path="/login" component={LoginPage} />

        <ProtectedRoute path="/config" component={Config}></ProtectedRoute>
        <ProtectedRoute path="/logout" component={Logout}></ProtectedRoute>
      </IonRouterOutlet>
    </IonReactRouter>
  );
}

function Logout() {
  const auth = useAuth();
  useEffect(() => {
    auth.logout();
  }, [auth]);
  return <Redirect to="/login" />;
}
